const defaultHeaders = {
  headers: {
    Authorization: "Bearer " + sessionStorage?.jwt,
  },
};
export async function Get(endpoint) {
  return fetch(endpoint, {
    ...defaultHeaders,
    method: "GET",
  });
}

export async function Post(endpoint, body) {
  return fetch(endpoint, {
    ...defaultHeaders,
    method: "POST",
    body: body,
  });
}

export async function PostAction(endpoint, body) {
  fetch(endpoint, {
    headers: {
      "Content-Type": "application/json",
      ...defaultHeaders.headers,
    },
    method: "POST",
    body: JSON.stringify(body),
  })
    .then((response) => {
      switch (response.status) {
        case 200:
          response.jsons().then((args) => {
            return [args, false];
          });

        default:
          return [null, true];
      }
    })
    .catch((error) => {
      return [null, true];
    });
}

export async function GetAction(endpoint) {
  fetch(endpoint, {
    ...defaultHeaders,
    method: "GET",
  })
    .then((response) => {
      if (response.status === 200) {
        response.json().then((args) => {
          return args;
        });
      } else {
        return null, false;
      }
    })
    .catch((error) => {
      return null, true;
    });
}

export async function getData(endpoint) {
  try {
    const response = await fetch(endpoint, {
      ...defaultHeaders,
      method: "GET",
    });

    if (response.status === 200) {
      const data = await response.json();
      return [data, false];
    } else {
      return [null, true];
    }
  } catch (error) {
    console.error("Error:", error);
    return [null, true];
  }
}

export async function postData(endpoint, body) {
  try {
    const response = await fetch(endpoint, {
      headers: {
        "Content-Type": "application/json",
        ...defaultHeaders.headers,
      },
      method: "POST",
      body: JSON.stringify(body),
    });

    if (response.status === 200) {
      const responseData = await response.text();
      const data = responseData ? JSON.parse(responseData) : null;
      return [data, false];
    } else {
      return [null, true];
    }
  } catch (error) {
    console.error("Error:", error);
    return [null, true];
  }
}

export async function postFormData(endpoint, body) {
  try {
    const response = await fetch(endpoint, {
      method: "POST",
      body: body,
      ...defaultHeaders,
    });

    if (response.status === 200) {
      const responseData = await response.text();
      const data = responseData ? JSON.parse(responseData) : null;
      return [data, false];
    } else {
      return [null, true];
    }
  } catch (error) {
    console.error("Error:", error);
    return [null, true];
  }
}

export async function deleteData(endpoint, id) {
  try {
    const response = await fetch(endpoint + "?id=" + id, {
      headers: {
        "Content-Type": "application/json",
        ...defaultHeaders,
      },
      method: "DELETE",
    });

    if (response.status === 200) {
      const responseData = await response.text();
      const data = responseData ? JSON.parse(responseData) : null;
      return [data, false];
    } else {
      return [null, true];
    }
  } catch (error) {
    return [null, true];
  }
}
